import http from '@/helpers/axios';

export function login (data) {
  return http.request({
    url: '/homepage_admin/user_center/login',
    method: 'post',
    data
  });
}

export function logout (params) {
  return http.request({
    url: '/aido/mall/user_center/logout',
    method: 'get',
    params
  });
}

export function getPermission (params) {
  return http.request({
    url: '/aido/mall/accounts/permission/',
    method: 'get',
    params
  });
}
